import React from "react";
import { Box } from "@mui/material";
import Header from "components/Header";
import BreakdownChart from "components/BreakdownChart";
import { useGetPartnerUserSubscriptionsQuery } from "state/api";
import { useOutletContext } from "react-router-dom";

const Breakdown = () => {
  const [userData] = useOutletContext()
  const {data , isLoading}  = useGetPartnerUserSubscriptionsQuery(userData.userData[0].userReferralCode);
  return (
    <Box m="1.5rem 2.5rem">
      <Header title="BREAKDOWN" subtitle="Breakdown of Sales By Pain Point Category" />
      <Box mt="40px" height="75vh">
      {userData &&  <BreakdownChart data={data}/>}
      </Box>
    </Box>
  );
};

export default Breakdown;